import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { SiteContext } from "../contexts/SiteContext";
import {
	Grid,
	Paper,
	IconButton,
	InputBase,
	Divider,
	Fade,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../inc/edu-logo.png";

function Home() {
	const { selectedSite } = useContext(SiteContext);
	const [searchValue, setSearchValue] = useState();
	const history = useHistory();

	const useStyles = makeStyles((theme) => ({
		root: {
			backgroundColor: selectedSite.secondaryColor
				? selectedSite.secondaryColor
				: "#333",
		},
		inner: {
			flexGrow: 1,
			color: "white",
			padding: "2rem 1rem",
			maxWidth: process.env.REACT_APP_MAX_WIDTH,
			margin: "0 auto",
		},
		siteLogo: {
			maxWidth: "400px",
		},
		headerLeft: {
			display: "flex",
			padding: "1rem",
			alignItems: "center",
			justifyContent: "flex-start",
			[theme.breakpoints.down("xs")]: {
				justifyContent: "center",
			},
		},
		headerRight: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			[theme.breakpoints.down("xs")]: {
				justifyContent: "center",
			},
		},
		search: {
			padding: ".1rem .25rem",
			display: "flex",
			alignItems: "center",
			width: "50%",
			[theme.breakpoints.down("md")]: {
				width: "100%",
			},
		},
		searchInput: {
			width: "100%",
		},
	}));

	const classes = useStyles();

	const onChange = (e) => {
		setSearchValue(e.target.value);
	};

	const sendSearch = (e) => {
		e.preventDefault();
		console.log(e);
		history.push(`/${selectedSite.slug}/search/${searchValue}`);
	};

	return (
		<Fade in={typeof selectedSite != undefined}>
			<div className={classes.root}>
				<div className={classes.inner}>
					<Grid container spacing={3}>
						<Grid item className={classes.headerLeft} xs={12} sm={5}>
							<a href="https://www.lva.virginia.gov/collections/educator-resources"><img className={classes.siteLogo} src={logo} alt="Library of Virginia Logo" /></a>
						</Grid>
						<Grid item className={classes.headerLeft} xs={12} sm={2}></Grid>
						<Grid item className={classes.headerRight} xs={12} sm={5}>
							<Paper
								onSubmit={sendSearch}
								component="form"
								className={classes.search}
							>
								<IconButton
									aria-label="Search Submit Button"
									onClick={sendSearch}
								>
									<SearchIcon />
								</IconButton>
								<InputBase
									className={classes.searchInput}
									placeholder="Search"
									inputProps={{ "aria-label": "Search" }}
									onChange={onChange}
								/>
								<Divider className={classes.divider} orientation="vertical" />
							</Paper>
						</Grid>
					</Grid>
				</div>
			</div>
		</Fade>
	);
}

export default Home;
